import { useTranslation } from "react-i18next";

import { APP_LINKS } from "../lib/constants";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

type BadgeProps = {
  className?: string;
};

const SHARED_BADGE =
  "inline-flex items-center justify-center gap-3 rounded-xl px-5 py-3 " +
  "transition-transform duration-150 hover:-translate-y-0.5 " +
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500";

export function AppStoreBadge({ className = "" }: BadgeProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (window.fbq) {
      window.fbq('trackCustom', 'AppDownloadClick');
    }
  };

  return (
    <a
      href={APP_LINKS.appStore}
      aria-label={t("badges.app_store_aria")}
      className={`${SHARED_BADGE} bg-black text-white ${className}`}
      onClick={handleClick}
    >
      <svg
        viewBox="0 0 24 24"
        className="h-7 w-7"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M17.564 12.69c-.025-2.53 2.069-3.747 2.163-3.806-1.18-1.726-3.014-1.962-3.665-1.99-1.561-.158-3.046.92-3.838.92-.793 0-2.013-.898-3.31-.873-1.703.025-3.27.99-4.143 2.512-1.768 3.063-.45 7.6 1.27 10.087.838 1.22 1.838 2.586 3.148 2.537 1.265-.05 1.742-.819 3.272-.819 1.53 0 1.957.819 3.295.793 1.36-.025 2.225-1.238 3.058-2.465.964-1.418 1.36-2.793 1.385-2.866-.03-.013-2.66-1.021-2.688-4.054ZM15.1 5.21c.7-.85 1.171-2.029.99-3.198-1.008.04-2.225.673-2.948 1.522-.648.75-1.217 1.948-1.064 3.106 1.123.087 2.27-.572 3.022-1.43Z" />
      </svg>
      <div className="text-start leading-tight">
        <p className="text-[10px] uppercase tracking-wide opacity-80">
          {t("badges.app_store_caption")}
        </p>
        <p className="text-lg font-semibold leading-tight">
          {t("badges.app_store_label")}
        </p>
      </div>
    </a>
  );
}

export function GooglePlayBadge({ className = "" }: BadgeProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (window.fbq) {
      window.fbq('trackCustom', 'AppDownloadClick');
    }
  };

  return (
    <a
      href={APP_LINKS.googlePlay}
      aria-label={t("badges.google_play_aria")}
      className={`${SHARED_BADGE} bg-black text-white ${className}`}
      onClick={handleClick}
    >
      <svg viewBox="0 0 512 512" className="h-7 w-7" aria-hidden="true">
        <path fill="#34A853" d="M325.3 234.3 104.5 16.2 376.7 188.3z" />
        <path fill="#FBBC04" d="M376.7 188.3 325.3 234.3 376.7 281.7 467.6 234.3z" />
        <path fill="#4285F4" d="M104.5 16.2 38.7 84 38.7 384.7 104.5 452.5 325.3 234.3z" />
        <path fill="#EA4335" d="M104.5 452.5 376.7 281.7 325.3 234.3z" />
      </svg>
      <div className="text-start leading-tight">
        <p className="text-[10px] uppercase tracking-wide opacity-80">
          {t("badges.google_play_caption")}
        </p>
        <p className="text-lg font-semibold leading-tight">
          {t("badges.google_play_label")}
        </p>
      </div>
    </a>
  );
}

type GroupProps = {
  className?: string;
};

export function AppStoreBadges({ className = "" }: GroupProps) {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <AppStoreBadge />
      <GooglePlayBadge />
    </div>
  );
}
